import { forwardRef, useMemo } from 'react';
import { LayoutUtils, useLayoutManager, usePanelId } from '@deephaven/dashboard';
import useLoadTablePlugin from "./useLoadTablePlugin.js";
import { jsx as _jsx } from "react/jsx-runtime";
export var TablePluginWrapper = /*#__PURE__*/forwardRef((_ref, ref) => {
  var name = _ref.name,
    model = _ref.model,
    filter = _ref.filter,
    fetchColumns = _ref.fetchColumns,
    selectedRanges = _ref.selectedRanges,
    irisGridRef = _ref.irisGridRef,
    pluginState = _ref.pluginState,
    onStateChange = _ref.onStateChange;
  var loadPlugin = useLoadTablePlugin();
  var Plugin = useMemo(() => loadPlugin(name), [loadPlugin, name]);
  var layoutManager = useLayoutManager();
  var panelId = usePanelId();
  var panelName = useMemo(() => {
    var _panelItem$config$tit;
    if (panelId == null) {
      return 'unknown';
    }
    var panelItem = LayoutUtils.getContentItemById(layoutManager.root, panelId);
    return (_panelItem$config$tit = panelItem === null || panelItem === void 0 ? void 0 : panelItem.config.title) !== null && _panelItem$config$tit !== void 0 ? _panelItem$config$tit : 'unknown';
  }, [layoutManager.root, panelId]);
  var panel = useMemo(() => ({
    irisGrid: irisGridRef,
    getTableName: () => panelName
  }), [irisGridRef, panelName]);
  return /*#__PURE__*/_jsx("div", {
    className: "iris-grid-plugin",
    children: /*#__PURE__*/_jsx(Plugin, {
      ref: ref,
      filter: filter,
      fetchColumns: fetchColumns,
      model: model,
      table: model.table,
      tableName: panelName,
      selectedRanges: selectedRanges,
      onStateChange: onStateChange,
      pluginState: pluginState
      // Mimic the panel containing `irisGrid.current` for backwards compatibility
      // since we don't have an IrisGridPanel to use here.
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ,
      panel: panel
    })
  });
});
TablePluginWrapper.displayName = 'TablePluginWrapper';
export default TablePluginWrapper;
//# sourceMappingURL=TablePluginWrapper.js.map